import { render, staticRenderFns } from "./MarketplaceSettings.vue?vue&type=template&id=a8a5d710&"
import script from "./MarketplaceSettings.vue?vue&type=script&lang=js&"
export * from "./MarketplaceSettings.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceSettings.vue?vue&type=style&index=0&id=a8a5d710&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8a5d710')) {
      api.createRecord('a8a5d710', component.options)
    } else {
      api.reload('a8a5d710', component.options)
    }
    module.hot.accept("./MarketplaceSettings.vue?vue&type=template&id=a8a5d710&", function () {
      api.rerender('a8a5d710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/SettingsList/MarketplaceSettings.vue"
export default component.exports